import type { LucideIcon } from 'lucide-react';
import { ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';

import { cn } from '@/lib/utils';

export function SettingsHubCard({
  href,
  icon: Icon,
  title,
  description,
}: {
  href: string;
  icon: LucideIcon;
  title: string;
  description: string;
}) {
  return (
    <Link
      to={href}
      className={cn(
        'group text-fin-gray-300 flex w-full min-w-0 items-center gap-3 px-4 py-3.5 text-left text-sm transition-colors',
        'hover:bg-fin-gray-800/40 hover:text-fin-white'
      )}
    >
      <span className='flex size-9 shrink-0 items-center justify-center'>
        <Icon className='text-fin-gray-500 size-5' aria-hidden />
      </span>
      <span className='min-w-0 flex-1'>
        <span className='text-fin-white block font-semibold'>{title}</span>
        <span className='text-fin-gray-500 mt-0.5 hidden text-xs leading-relaxed sm:block'>
          {description}
        </span>
      </span>
      <ChevronRight
        className='text-fin-gray-600 size-4 shrink-0 transition-transform group-hover:translate-x-0.5'
        aria-hidden
      />
    </Link>
  );
}
